<template>
  <div>
    <b-row>
      <b-col>
        <b-form-group>
          <label class="font-weight-bold" for="name"
            >Buscar proveedor por:</label
          >
          <b-form-radio-group
            size="sm"
            v-model="companyTypeSearch"
            :options="optionsTypeSearch"
            class="mb-3"
            value-field="value"
            text-field="text"
            disabled-field="notEnabled"
          />
          <label class="font-weight-bold" for="name">Proveedor</label>
          <search-select
            v-model="$v.form.company.$model"
            @blur="handleBlur"
            :validation="$v.form.company"
            :url="urlSearchCompany"
          />
        </b-form-group>
        <b-form-group>
          <label class="font-weight-bold" for="name">Nº Documento</label>
          <b-form-input
            autocomplete="off"
            type="text"
            v-model="$v.form.document_number.$model"
            :state="
              $v.form.document_number.$dirty
                ? !$v.form.document_number.$error
                : null
            "
            id="name"
            placeholder="12345"
          />
        </b-form-group>
        <b-form-group>
          <label class="font-weight-bold" for="name">Fecha</label>
          <b-form-input
            autocomplete="off"
            type="date"
            v-model="$v.form.document_date.$model"
            :state="
              $v.form.document_date.$dirty
                ? !$v.form.document_date.$error
                : null
            "
          />
        </b-form-group>
        <b-form-group>
          <label class="font-weight-bold" for="name"
            >Kilogramos informados</label
          >
          <b-form-input
            autocomplete="off"
            type="text"
            v-model="$v.form.document_kilograms.$model"
            :state="
              $v.form.document_kilograms.$dirty
                ? !$v.form.document_kilograms.$error
                : null
            "
            v-on:keyup="inputSoloNumeroDecimal"
            placeholder="12345"
          />
        </b-form-group>
        <b-form-group>
          <label class="font-weight-bold" for="name">Tipo Documento</label>
          <v-select
            :class="classObject"
            v-model="$v.form.document_type.$model"
            :state="
              $v.form.document_type.$dirty
                ? !$v.form.document_type.$error
                : null
            "
            label="text"
            :options="document_types"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-card
          class="h-75"
          bg-variant="secondary"
          :title="form.company.company_name"
        >
          <b-card-text>
            <p><b>Rut: </b> {{ form.company.text }}</p>
            <p>
              <b>Dirección: </b> {{ form.company.address1 }} <br />
              {{ form.company.address2 }}
            </p>
            <p><b>Teléfono: </b>{{ form.company.phone }}</p>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-button
          class="mb-3"
          :disabled="
            !form.company || !form.document_type || !form.document_number
          "
          v-b-modal.modal-1
          >Agregar producto
        </b-button>
        <b-button
          disabled
          v-if="items.length > 0"
          :class="checkCompletedPallet ? 'ml-2 mb-3' : 'ml-2 mb-3 text-dark'"
          :variant="
            checkCompletedPallet ? 'outline-success' : 'outline-secondary'
          "
        >
          Pallets pesados: {{ completedPallet }} / {{ items.length }}
        </b-button>
        <b-button
          v-if="items.length > 0"
          class=" ml-2 mb-3"
          variant="danger"
          @click.prevent="removeAll"
          >Eliminar todo
        </b-button>
      </b-col>
      <b-col>
        <select-scale class="float-right" size="md" />
        <bulk-pallet-set />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <create-content-table :form="form" ref="table" />
      </b-col>
    </b-row>

    <div>
      <div>
        <b-modal
          size="md"
          @ok="onSubmit"
          @show="$v.$reset()"
          id="modal-1"
          title="Agregar producto"
        >
          <b-form-group>
            <label class="font-weight-bold" for="name"
              >Código de Producto</label
            >
            <search-select
              v-model="$v.form.product.$model"
              :submitStatus="submitActive"
              :validation="$v.form.product"
              url="/bagno/product/select_product/"
            />

            <!--            If you need to discard all PT, use the commented url bellow. -->
            <!--            <search-select v-model="form.product" url="/bagno/product/select_product/?excluded_product_type=PT"/>-->
          </b-form-group>

          <b-form-radio-group
            v-model="form.pallet_type"
            @change="pallet_grouped = 1"
            :options="pallet_types"
            class="mb-3"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
          />
          <b-form-group>
            <label class="font-weight-bold" for="name">Nº Pallets/Bins</label>
            <b-form-input
              type="number"
              v-model="$v.form.pallet_quantity.$model"
              :state="
                $v.form.pallet_quantity.$dirty
                  ? !$v.form.pallet_quantity.$error
                  : null
              "
              autocomplete="off"
              v-on:keyup="inputSoloNumero"
            >
            </b-form-input>
          </b-form-group>

          <b-form-group>
            <label class="font-weight-bold" for="name">Recipiente</label>
            <v-select
              :class="classObjectContainer"
              :clearable="false"
              v-model="$v.form.container.$model"
              :state="
                $v.form.container.$dirty ? !$v.form.container.$error : null
              "
              label="text"
              :options="containers"
            />
          </b-form-group>

          <b-form-group>
            <label class="font-weight-bold" for="name">Peso Envase</label>
            <b-form-input
              autocomplete="off"
              type="text"
              v-model="$v.form.material_weight.$model"
              :state="
                $v.form.material_weight.$dirty
                  ? !$v.form.material_weight.$error
                  : null
              "
              v-on:keyup="inputSoloNumeroDecimal"
              placeholder=""
            />
          </b-form-group>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import createContentTable from "./CreateContentTable.vue";
import { integer, required, decimal } from "vuelidate/lib/validators";
import { mapState, mapGetters } from "vuex";
import selectScale from "../../../views/reusable/selectScale";
import searchSelect from "../../searchSelect";
import { getBagnoLot } from "./getBagnoLot";
import BulkPalletSet from "./BulkPalletSet";

export default {
  name: "CreateContent",
  components: {
    createContentTable,
    selectScale,
    BulkPalletSet,
    searchSelect
  },
  data() {
    return {
      pallet_grouped: 1,
      pallet_types: [
        { item: "BINS", name: "BINS" },
        { item: "PALLETS", name: "PALLETS" }
      ],
      pallet_grouping: [
        { item: 1, name: 1 },
        { item: 2, name: 2 },
        { item: 3, name: 3 }
      ],
      document_types: [
        { text: "Guía de despacho", value: 0 },
        { text: "Factura", value: 1 },
        { text: "Otro", value: 2 }
      ],
      submitActive: false,
      companyTypeSearch: "1",
      optionsTypeSearch: [
        { text: "Rut", value: "1" },
        { text: "Nombre", value: "2" }
      ]
    };
  },
  props: {
    form: {
      type: Object,
      default: {}
    }
  },
  computed: {
    classObject: function() {
      return {
        "custom-select": true,
        "style-chooser": true,
        "is-valid":
          this.form.document_type != null &&
          this.$v.form.document_type.$dirty == true
            ? true
            : false,
        "is-invalid":
          this.form.document_type == null &&
          (this.$v.form.document_type.$dirty == true ||
            this.submitActive == true)
            ? true
            : false
      };
    },
    classObjectContainer: function() {
      return {
        "custom-select": true,
        "style-chooser": true,
        "is-valid":
          this.form.container.text != null &&
          this.$v.form.container.$dirty == true
            ? true
            : false,
        "is-invalid":
          this.form.container.text == null &&
          (this.$v.form.container.$dirty == true || this.submitActive == true)
            ? true
            : false
      };
    },
    urlSearchCompany: function() {
      return "/bagno/company/select_company/?type=" + this.companyTypeSearch;
    },
    ...mapGetters("bagnoArrivalModule", [
      "completedPallet",
      "checkCompletedPallet"
    ]),
    ...mapState("bagnoArrivalModule", ["items", "containers"])
  },
  watch: {
    "form.pallet_type": function(obj) {
      if (obj == "BINS") {
        this.form.container.finished_product = false;
        this.form.container.gross_weight = "34000";
        this.form.container.id = "1";
        this.form.container.material_weight = "40000";
        this.form.container.net_weight = "30000";
        this.form.container.text = "BIN";
        this.$store.dispatch("bagnoArrivalModule/getContainers", obj);
      } else {
        this.form.container.material_weight = null;
        this.form.container.text = null;
        this.$store.dispatch("bagnoArrivalModule/getContainers", obj);
      }
    }
  },
  methods: {
    debug(event) {
      console.log(event.target.name);
    },
    handleBlur(evt) {
      // alert(JSON.stringify(evt))
    },
    resetForm() {
      this.form.product = null;
      this.form.pallet_quantity = null;
    },
    addRow() {
      const pallet_type = this.form.pallet_type;
      const data = {
        lot: getBagnoLot(
          this.form.product.fruit_code,
          this.form.company.code,
          this.form.document_date
        ),
        pallet_quantity: this.form.pallet_quantity,
        code: this.form.product.code,
        description: this.form.product.name,
        product_id: this.form.product.id,
        quantity: null,
        gross_weight: null,
        net_weight: null,
        container: this.form.container,
        material_weight: this.form.material_weight,
        pallet_type: pallet_type
      };
      this.$store.dispatch("bagnoArrivalModule/getContainers", pallet_type);
      this.$store.dispatch("bagnoArrivalModule/addRows", data);
      this.form.pallet_quantity = null;
    },
    removeAll() {
      this.$store.dispatch("bagnoArrivalModule/removeAll");
    },
    onSubmit(evt) {
      this.$v.form.$touch();
      this.submitActive = true;
      if (this.$v.$invalid) {
        evt.preventDefault();
        this.$toast.info("Campos restantes en el formulario", "");
      } else {
        this.addRow();
        this.resetForm();
        this.$nextTick(() => {
          this.$bvModal.hide("modal-1");
        });
      }
    },
    inputSoloNumero(event) {
      event.target.value = event.target.value.replace(/[^0-9]/, "");
    },
    inputSoloNumeroDecimal(event) {
      event.target.value = event.target.value.replace(/[^0-9.]/, "");
    }
  },
  validations: {
    form: {
      pallet_quantity: { required, integer },
      product: {
        fruit_code: { required }
      },
      container: {
        text: { required },
        material_weight: { required }
      },
      company: { required },
      document_type: { required },
      document_kilograms: { decimal },
      document_date: { required },
      document_number: { required },
      material_weight: { required }
    }
  },
  mounted() {
    this.$store.dispatch("bagnoArrivalModule/getContainers", this.pallet_type);
    //inicializo en BIN
    this.form.container.finished_product = false;
    this.form.container.gross_weight = "34000";
    this.form.container.id = "1";
    this.form.container.material_weight = "40000";
    this.form.container.net_weight = "30000";
    this.form.container.text = "BIN";
  }
};
</script>

<style>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  min-height: calc(1.5em + 0.75rem + 2px);
  font-size: 0.6875rem;
  font-weight: 400;
  color: #5c6873;
  border: none;
  margin-top: -7px;
  margin-left: -10px;
}
.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #394066;
}
</style>
